/*
 * Error handling utilities.
 */

/**
 * Throws an HTTP error, normalizing specific cases like oversized payloads.
 * The status is required so we know how to handle errors without a message.
 * @param {object} data - The response body from the server.
 * @param {number} status - The HTTP status code.
 * @throws {object} An error object with `_error` and `message` fields.
 */
export const throwHttpError = (data, status) => {
  const errorMessage = {
    413: 'The request was too large!',
    500: 'There was an unexpected server error.',
  }[status];

  if (data?.message === '' && errorMessage !== undefined) {
    // The error is caught and expected to be the payload from
    // the server (i.e. `data`).
    // eslint-disable-next-line no-throw-literal
    throw {
      _error: [],
      message: errorMessage,
    };
  } else {
    throw data;
  }
};
